/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useContext, createContext, useState, useEffect } from 'react';
import { Participant } from 'twilio-video';

type SelectedParticipantContext = [Participant | null, (participant: Participant) => void];
const SelectedParticipantContext = createContext(null as unknown as any);

export function useSelectedParticipant() {
  const [selectedParticipant, setSelectedParticipant] =
    useContext<SelectedParticipantContext>(SelectedParticipantContext);
  return [selectedParticipant, setSelectedParticipant] as const;
}

/*
 * todo: This provider seems to be deprecated. I don't see it being used anywhere in the codebase.
 */
export const SelectedParticipantProvider: React.SFC<{ room: VideoProvider.IRoom | null }> = ({ children, room }) => {
  const [selectedParticipant, _setSelectedParticipant] = useState<Participant | null>(null);
  const setSelectedParticipant = (participant: Participant) =>
    _setSelectedParticipant(prevParticipant => (prevParticipant === participant ? null : participant));

  useEffect(() => {
    // todo: ignore this for zoom sdk because this seems to be not being used anywhere
    if (room && room.on) {
      const onDisconnect = () => _setSelectedParticipant(null);
      room.on?.('disconnected', onDisconnect);
      return () => {
        room.off?.('disconnected', onDisconnect);
      };
    }
    return () => {};
  }, [room]);

  return (
    <SelectedParticipantContext.Provider value={[selectedParticipant, setSelectedParticipant]}>
      {children}
    </SelectedParticipantContext.Provider>
  );
};
